import React from 'react'

export interface IBreadcrumbSecondaryItem {
  name: string
  url: string
  index: number
}

export interface BreadcrumbSecondaryItemProps {
  item: IBreadcrumbSecondaryItem
}

const BreadcrumbSecondaryItem = (props: BreadcrumbSecondaryItemProps) => {
  return (
    <>
      <li>
        <a href={props.item.url}>{props.item.name}</a>
      </li>
    </>
  )
}
export default BreadcrumbSecondaryItem
